/**
 * The card treatment shared by the bubbles anchored to a mark on the map: the
 * competitor-station popup and the traffic hover tooltip. The type — title, row,
 * label, value — is the zone card's (`ZoneMapCard`), so a station reads like a
 * zone; the surface is the translucent one those bubbles need over map content.
 *
 * Distinct from `MAP_PANEL_SURFACE`, which dresses the panels floating in the
 * map's corners (callouts, onboarding, tool shell): those are opaque cards on
 * the map's chrome, these are translucent bubbles pinned over its content.
 *
 * Width stays at the call site — each bubble sizes to what it holds.
 */
export const MAP_BUBBLE_SURFACE =
  'rounded-md border border-border bg-background/95 p-2.5 text-xs shadow-md backdrop-blur-sm';

/** The bubble's headline: the zone, station or road it describes. */
export const MAP_BUBBLE_TITLE = 'text-sm font-semibold leading-snug';

/** One label/value line, divided from whatever sits above it. */
export const MAP_BUBBLE_ROW =
  'mt-1.5 flex items-center justify-between gap-2 border-t border-border/60 pt-1.5';

export const MAP_BUBBLE_LABEL = 'text-muted-foreground';

export const MAP_BUBBLE_VALUE = 'font-medium';
